(() => {
  if (window.BioselfProductCards) return;

  const setStatus = (form, message = '') => {
    const card = form.closest('[data-product-card]');
    const status = card?.querySelector('[data-product-card-status]');
    if (status) status.textContent = message;
  };

  const submit = async (form) => {
    const button = form.querySelector('button[type="submit"]');
    if (button?.disabled) return;

    setStatus(form);
    button?.setAttribute('disabled', 'disabled');
    button?.setAttribute('aria-busy', 'true');

    try {
      const formData = new FormData(form);
      const response = await fetch(`${window.routes?.cartAddUrl || '/cart/add'}.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });
      const payload = await response.json().catch(() => ({}));
      if (!response.ok) throw payload;

      form.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: payload,
          quantity: Number.parseInt(formData.get('quantity') || '1', 10),
        },
      }));
    } catch (error) {
      const message = error.description || error.message || 'Não foi possível adicionar este produto ao carrinho.';
      setStatus(form, message);
      form.dispatchEvent(new CustomEvent('product:add-error', {
        bubbles: true,
        detail: { error, trigger: button },
      }));
    } finally {
      button?.removeAttribute('disabled');
      button?.removeAttribute('aria-busy');
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-product-card-form]');
    if (!form) return;
    event.preventDefault();
    submit(form);
  });

  window.BioselfProductCards = { submit };
})();
